import {
    StyleSheet
} from "react-native";

export const ALERT_DESCRIPTION_VARIANT: keyof NCoreUIKit.Typography = "bodyMediumSize";

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 1
    }
});
export default stylesheet;
